<template>
  <rabbey-table3
    ref="rTable"
    :data="items"
    :columns="columns"
    :actions="actions"
    :border="true"
    :stripe="true"
    :search="search"
    paginateFromApi
    :paginationApi="paginationApi"
    :pageSizes="paginationApi.pageSizes"
    v-loading="loading"
    @rtable-push-action="$emit('rtable-push-action', $event)"
    @update-page-size="$emit('update-page-size', $event)"
    @update-current-page="$emit('update-current-page', $event)"
  >
  </rabbey-table3>
</template>

<script>
import prospectActions from "./prospectActions";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import { mapActions, mapMutations } from "vuex";
import { PAGINATION_DEFAULT } from "@/const";

export default {
  name: "ProspectTable",
  props: {
    search: {
      type: String,
      default: null,
      required: false
    },
    filterList: {
      type: Array,
      default: null,
      required: false
    },
    module: {
      type: String,
      required: false,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    paginationApi: {
      type: Object,
      required: false,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 500],
        total: 0
      })
    }
    // ,
    // currentPage: {
    //   type: Number,
    //   default: 1
    // },
    // pageSize: {
    //   type: Number,
    //   default: 10
    // },
    // totalItems: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      columns: [
        {
          prop: "status_procpects",
          label: "Activo",
          width: 100,
          sortable: true,
          formatter: (props) => {
            if (props.status_procpects == 1) {
              return "✔️";
            }
            return "❌";
          }
        },
        {
          prop: "ContactCode",
          label: "Codigo",
          width: 130,
          fixed: true
        },
        {
          prop: "CompanyName",
          label: "Empresa",
          width: 300,
          sortable: true
        },
        // {
        //   prop: "Name",
        //   label: "Nombre",
        //   minWidth: 420
        // }
        {
          prop: "DealsCount",
          name: "Negotiations",
          label: "Negociaciones",
          width: 150,
          sortable: true,
          align: "center"
        },
        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 220,
          formatter: ImagePerson,
          attrs: {
            imgKey: "SurImageUrl"
          },
          sortable: true
        },
        {
          prop: "City",
          label: "Ciudad",
          minWidth: 200
        },

        {
          prop: "CreatedAt",
          label: "Creacion",
          minWidth: 120,
          formatter: DatetimeFormatter,
          attrs: {
            onlyDate: true
          }
        },
        {
          prop: "CreatedName",
          label: "Creador",
          minWidth: 200,
          formatter: ImagePerson,
          attrs: {
            imgKey: "CreatedImageUrl"
          },
          sortable: true
        },
        {
          prop: "EmployeesAmount",
          label: "Empleados"
        },
        {
          prop: "ComputersAmount",
          label: "Computadoras"
        },
        {
          prop: "ClientsAmount",
          label: "Clientes"
        },
        {
          prop: "VehiculesAmount",
          label: "Vehiculos"
        },
        {
          prop: "JobTitle",
          label: "Posicion",
          width: 150
        },
        {
          prop: "Email",
          label: "Email",
          minWidth: 300
        },
        {
          prop: "ContactAddress",
          label: "Direccion",
          minWidth: 150
        }
      ],
      actions: prospectActions
    };
  },
  created() {
    this.paginate(PAGINATION_DEFAULT);
  },
  methods: {
    ...mapMutations({
      setOriginalItems: "rabbey_table/originalItems",
      setUrl: "rabbey_table/url"
    }),
    ...mapActions({ paginate: "rabbey_table/paginate" })
  }
};
</script>

<style></style>
